// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State } from '../../../services/types.tsx';
import { setOpenTaskId } from '../set-open-task-id/set-open-task-id.tsx';

export const continueToNextTask =
	(): Action<State> =>
	({ getState, dispatch }) => {
		const { tasks, openTaskId } = getState();
		if (!openTaskId || !tasks) {
			return;
		}

		const openTaskIndex = tasks.items.findIndex((task) => task.id === openTaskId);

		if (openTaskIndex === -1) {
			return;
		}

		// Find the first uncompleted task after the current task
		for (let i = openTaskIndex + 1; i < tasks.items.length; i++) {
			const task = tasks.items[i];
			if (!task.completed) {
				dispatch(setOpenTaskId({ id: task.id }));
				return;
			}
		}
	};
